<mat-card class="dialog-content">
  <mat-card-header class="dialog-header">
    <div class="header-content">
      <mat-card-title>{{ data.title }}</mat-card-title>
      <mat-card-subtitle>
        @if (fileItem.name) {
          <span>Name: {{ fileItem.name }}&nbsp;</span>
        }
        @if (sizeFormatted) {
          <span>Size: {{ sizeFormatted }}&nbsp;</span>
        }
        @if (fileItem.createdAt) {
          <span
            >Created at: {{ fileItem.createdAt | serverDate: "short" }}&nbsp;</span
          >
        }
        @if (fileItem.modifiedAt) {
          <span>Modified at: {{ fileItem.modifiedAt | serverDate: "short" }}</span>
        }
      </mat-card-subtitle>
    </div>
    @if (data.hasClose) {
      <button mat-icon-button [mat-dialog-close]="false" class="close-button">
        <mat-icon>close</mat-icon>
      </button>
    }
  </mat-card-header>

  <mat-card-content>
    @switch (fileItem.fileType) {
      @case ("image") {
        <div>
          @if (base64()) {
            <img
              appImgFallback
              class="preview-image img-fluid rounded mx-auto d-block"
              [attr.src]="base64() | safe: 'resourceUrl'"
              alt="group attachment preview"
            />
          }
        </div>
      }
      @case ("video") {
        <div>
          @if (base64()) {
            <video
              width="1024"
              height="500"
              controls="controls"
              preload="auto"
              autoplay
            >
              <source [attr.src]="base64()" type="video/mp4" />
              <source [attr.src]="base64()" type="video/webm" />
              <source [attr.src]="base64()" type="video/ogg" />
              <p>Your user agent does not support the HTML5 Video element.</p>
            </video>
          }
        </div>
      }
      @case ("audio") {
        <div>
          <audio
            class="w100"
            controls="controls"
            preload="auto"
            autoplay
            [attr.src]="base64()"
          >
            Your browser does not support the audio element.
          </audio>
        </div>
      }
      @case ("csv") {
        <div>
          @if (tableData()?.data?.length) {
            <app-custom-table
              [tableData]="tableData().data"
              [tableColumns]="tableData().columns"
              [isFilterable]="true"
              [isPageable]="true"
              [paginationSizes]="[10, 20, 50]"
              [defaultPageSize]="10"
              [pageSizeStorageKey]="pageSizeStorageKey"
              [isControlPanel]="true"
              controlPanelType="export"
            ></app-custom-table>
          }
        </div>
      }
      @case ("arrow") {
        <div>
          @if (tableData()?.data?.length) {
            <app-custom-table
              [tableData]="tableData().data"
              [tableColumns]="tableData().columns"
              [isFilterable]="true"
              [isPageable]="true"
              [paginationSizes]="[10, 20, 50]"
              [defaultPageSize]="10"
              [pageSizeStorageKey]="pageSizeStorageKey"
              [isControlPanel]="true"
              controlPanelType="export"
            ></app-custom-table>
          }
        </div>
      }
      @case ("md") {
        <app-code-editor
          (updateContent)="updateContent($event)"
          (startEdit)="setFormTouched()"
          [mode]="mode"
          [content]="data.model"
          [maximumHeight]="editorMaxHeight()"
        ></app-code-editor>
      }
      @case ("javascript") {
        <app-code-editor
          (updateContent)="updateContent($event)"
          (startEdit)="setFormTouched()"
          [mode]="mode"
          [content]="data.model"
          [maximumHeight]="editorMaxHeight()"
        ></app-code-editor>
      }
      @case ("python") {
        <app-code-editor
          (updateContent)="updateContent($event)"
          (startEdit)="setFormTouched()"
          [mode]="mode"
          [content]="data.model"
          [maximumHeight]="editorMaxHeight()"
        ></app-code-editor>
      }
      @case ("text") {
        <app-code-editor
          (updateContent)="updateContent($event)"
          (startEdit)="setFormTouched()"
          [mode]="mode"
          [content]="data.model"
          [maximumHeight]="editorMaxHeight()"
        ></app-code-editor>
      }
      @default {
        <div>
          <div class="alert alert-danger" role="alert">
            Sorry, preview is not available for this file type
          </div>
        </div>
      }
    }
  </mat-card-content>

  <mat-card-actions [align]="'end'" class="dialog-actions">
    @if (hasWritePermission()) {
      @if (data.confirmCaption) {
        <button
          mat-stroked-button
          color="primary"
          [mat-dialog-close]="data"
          class="action-button confirm-button"
          [disabled]="loading()"
          [class.loading]="loading()"
        >
          {{ data.confirmCaption }}
        </button>
      }
    }
    @if (data.cancelCaption) {
      <button
        mat-stroked-button
        color="warn"
        [mat-dialog-close]="false"
        class="action-button cancel-button"
        [disabled]="loading()"
        [class.loading]="loading()"
      >
        {{ data.cancelCaption }}
      </button>
    }
  </mat-card-actions>
</mat-card>
